export const CustomEventNames = {
  crm: {
    activities: {
      reloadActivityHome: 'reloadActivityHomeData',
    },
  },
  lighting: {
    reloadConfigHome: 'reloadLightingConfigHomeData',
  },
};
